import { createFileRoute, redirect } from '@tanstack/react-router';
import { sessionQueryOptions } from '@/features/auth/api';
import { TransactionsView } from '@/features/transactions/components/TransactionsView';

export const Route = createFileRoute('/_authenticated/transacoes')({
  // 0019: usuário em modo "Individual" não tem mais entrada "Transações" no menu — um
  // link antigo/favorito pra `/transacoes` cai na primeira página individual (Avulsos),
  // em vez de mostrar uma tela órfã que não existe mais na navegação. `ensureQueryData`
  // é cache-hit (o layout `_authenticated` já garantiu a sessão antes desta rota rodar).
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(sessionQueryOptions()).catch(() => null);
    if (user?.transactionsViewMode === 'individual') throw redirect({ to: '/transacoes/avulsos' });
  },
  component: () => <TransactionsView />,
});
